import AEMWrapper from "aem/ComponentWrapper";
import ContainerWrapper from "concierge-alias-aem/ContainerWrapper";
import meta from "./aem-meta";
import loadable from "@loadable/component";
import React from "react";

const Component = loadable(
  () =>
    import(
      /* webpackChunkName: "component-text/aem-component" */ "./aem-component"
    ),
  {
    fallback: <></>
  }
);

export default AEMWrapper(meta, Component, {
  wrapper: ContainerWrapper
});
